<template>
  <div class="breadcrumb el-card pg-card">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="el-card__body">
      <el-breadcrumb-item v-for="h in hierarchy" v-bind:key="h.path" v-if="h.meta.breadcrumb" :to="h.path">{{h.meta.breadcrumb}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  data () {
    return {
      hierarchy: null
    }
  },
  methods: {
    updateHierarchy () {
      this.hierarchy = this.$route.matched
    }
  },
  watch: {
    '$route' (to, from) {
      this.updateHierarchy()
    }
  },
  mounted () {
    this.updateHierarchy()
  }
}
</script>

<style lang="scss">

.breadcrumb {
  margin-bottom: 20px;
}

.el-breadcrumb__item:not(:last-child) .el-breadcrumb__inner {
  color: #d5d6d7;
  font-weight: normal;

  &:hover {
    color: #FF9900;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/shared/breadcrumb/Breadcrumb.vue